/* MW · Consent — the theme's side of Shopify's cookie banner.
   Shopify owns the banner, the preferences dialog, the stored choice and every
   tracking decision; nothing here reads or writes consent. This file only
   (1) offers a way back to the preferences once the banner is gone, through
   Shopify's own window.privacyBanner.showPreferences(), and
   (2) keeps keyboard focus in order around Shopify's dialog: the banner behind
   the open dialog is taken out of the tab order, and closing the dialog hands
   focus back to whatever opened it. */
(function () {
  'use strict';

  var PREFS_ID = 'shopify-pc__prefs';
  var BANNER_ID = 'shopify-pc__banner';
  var MANAGE_ID = 'shopify-pc__banner__btn-manage-prefs';
  var OPENER = '[data-mw-consent-open]';

  var trigger = null;

  function banner() {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'
      ? window.privacyBanner
      : null;
  }

  function shown(el) {
    return !!el && window.getComputedStyle(el).display !== 'none';
  }

  /* The footer link is rendered hidden and only offered once Shopify's banner
     script is on the page -- where the store shows no banner, there is no
     choice to return to and the link never appears. The script loads async,
     so look for it for a few seconds rather than once. */
  function revealOpeners() {
    var tries = 0;
    (function check() {
      if (banner()) {
        var slots = document.querySelectorAll('[data-mw-consent-slot]');
        for (var i = 0; i < slots.length; i++) slots[i].hidden = false;
        return;
      }
      if (++tries < 40) window.setTimeout(check, 250);
    })();
  }

  function restoreFocus() {
    var target = trigger;
    trigger = null;
    if (!target || !target.isConnected || !target.getClientRects().length) return;
    if (window.getComputedStyle(target).visibility === 'hidden') return;
    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      target.focus();
    }
  }

  function syncOpen(open) {
    var el = document.getElementById(BANNER_ID);
    if (el) el.inert = open;
    if (!open) restoreFocus();
  }

  /* Shopify builds the dialog on first use and afterwards only flips its
     inline display, so: wait for it to exist, then watch just that element. */
  function watchPrefs() {
    var bound = false;

    function bind(el) {
      if (bound) return;
      bound = true;
      var open = shown(el);
      if (open) syncOpen(true);
      new MutationObserver(function () {
        var now = shown(el);
        if (now === open) return;
        open = now;
        syncOpen(now);
      }).observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }

    var existing = document.getElementById(PREFS_ID);
    if (existing) return bind(existing);

    var waiting = new MutationObserver(function () {
      var el = document.getElementById(PREFS_ID);
      if (!el) return;
      waiting.disconnect();
      bind(el);
    });
    waiting.observe(document.body, { childList: true });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      var opener = target.closest(OPENER);
      if (opener) {
        var api = banner();
        if (!api) return;
        event.preventDefault();
        trigger = opener;
        api.showPreferences();
        return;
      }

      var manage = target.closest('#' + MANAGE_ID);
      if (manage) trigger = manage;
    },
    true
  );

  function init() {
    revealOpeners();
    watchPrefs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
